/**
 * Classification API -- barrel re-export for backward compatibility.
 *
 * T117: The monolithic classificationApi has been split into domain modules:
 *   - classificationCoreApi.js    -- CRUD, tree, transfers, integration, export
 *   - classificationScanApi.js    -- scans, rules, schedules, patterns, triage, quality, EDM
 *   - classificationReviewApi.js  -- reviews, campaigns, assignment, simulation
 *   - classificationAdminApi.js   -- article mappings, destinations, ML models, NCA
 *   - classificationAnalyticsApi.js -- dashboard, stats, intelligence, reports, analytics
 *
 * This barrel merges all sub-APIs into a single `classificationApi` object
 * so existing imports (`import { classificationApi } from '...'`) keep working.
 */

import { classificationCoreApi } from './classificationCoreApi';
import { classificationScanApi } from './classificationScanApi';
import { classificationReviewApi } from './classificationReviewApi';
import { classificationAdminApi } from './classificationAdminApi';
import { classificationAnalyticsApi } from './classificationAnalyticsApi';

export const classificationApi = {
  ...classificationCoreApi,
  ...classificationScanApi,
  ...classificationReviewApi,
  ...classificationAdminApi,
  ...classificationAnalyticsApi,
};

// Named re-exports for consumers who want to import specific sub-APIs
export {
  classificationCoreApi,
  classificationScanApi,
  classificationReviewApi,
  classificationAdminApi,
  classificationAnalyticsApi,
};
